import { string } from "yup"

export default string().email("Invalid email address").required("Required")
